(function () {
  const globalBreadcrumbSelector = '.breadcrumb[data-breadcrumb-context]';
  const articleBreadcrumbSelector = '.article-template__breadcrumbs[data-blog-breadcrumb]';
  const categoryConfig = window.ITMartCategoryNavigation || {};
  let categoryDataPromise;

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function appendHash(url, slug) {
    if (!url || !slug) return url || '';
    return url.indexOf('#') === -1 ? url + '#' + encodeURIComponent(slug) : url;
  }

  function softwareSectionHash(name) {
    const match = String(name || '').charAt(0).match(/[A-Z]/i);
    return 'category-letter-' + (match ? match[0].toUpperCase() : '#');
  }

  function parseHandleList(value) {
    if (!value) return [];
    return value
      .split('|')
      .map(function (item) {
        return item.trim();
      })
      .filter(Boolean);
  }

  function getCategoryData() {
    if (!categoryConfig.dataUrl) return Promise.resolve(null);

    if (!categoryDataPromise) {
      categoryDataPromise = fetch(categoryConfig.dataUrl, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) return null;
          return response.json();
        })
        .catch(function () {
          return null;
        });
    }

    return categoryDataPromise;
  }

  function buildCategoryIndex(payload) {
    const index = {
      collections: new Map(),
      pages: new Map()
    };
    const topCategories = Array.isArray(payload && payload.top_categories) ? payload.top_categories : [];

    topCategories.forEach(function (topCategory) {
      const topEntry = {
        handle: topCategory.slug || '',
        title: topCategory.name || '',
        url: topCategory.browse_page_url || ''
      };
      const isFlatCategory = Boolean(topCategory.is_flat_category);

      if (topEntry.handle) {
        index.pages.set(topEntry.handle, topEntry);
      }

      (topCategory.subcategories || []).forEach(function (subcategory) {
        const subEntry = isFlatCategory
          ? null
          : {
              title: subcategory.name || '',
              url: appendHash(topEntry.url, subcategory.slug || '')
            };

        if (subcategory.collection_handle && subcategory.collection_url && !index.collections.has(subcategory.collection_handle)) {
          index.collections.set(subcategory.collection_handle, {
            top: topEntry,
            sub: subEntry,
            sectionHash: isFlatCategory ? softwareSectionHash(subcategory.name) : subcategory.slug || '',
            collection: {
              title: subcategory.name || '',
              url: subcategory.collection_url || ''
            }
          });
        }

        (subcategory.final_categories || []).forEach(function (finalCategory) {
          if (!finalCategory.collection_handle || !finalCategory.collection_url) return;

          index.collections.set(finalCategory.collection_handle, {
            top: topEntry,
            sub: subEntry,
            sectionHash: isFlatCategory ? softwareSectionHash(subcategory.name) : subcategory.slug || '',
            collection: {
              title: finalCategory.name || '',
              url: finalCategory.collection_url || ''
            }
          });
        });
      });
    });

    return index;
  }

  function pushLink(items, title, url) {
    if (!title) return;

    if (url) {
      items.push({ type: 'link', title: title, url: url });
      return;
    }

    items.push({ type: 'current', title: title });
  }

  function pushCurrent(items, title) {
    if (!title) return;
    items.push({ type: 'current', title: title });
  }

  function pushParentPage(items, dataset) {
    if (dataset.parentPageTitle) {
      pushLink(items, dataset.parentPageTitle, dataset.parentPageUrl);
    }
  }

  function pushCategoryPath(items, entry, options) {
    if (!entry) return;

    pushLink(items, entry.top && entry.top.title, appendHash(entry.top && entry.top.url, entry.sectionHash));

    if (entry.sub && entry.sub.title) {
      pushLink(items, entry.sub.title, entry.sub.url);
    }

    if (options && options.currentCollection) {
      pushCurrent(items, options.currentCollection);
      return;
    }

    pushLink(items, entry.collection && entry.collection.title, entry.collection && entry.collection.url);
  }

  function findMappedCollection(dataset, index) {
    const explicitHandle = dataset.collectionHandle || '';
    const productHandles = parseHandleList(dataset.productCollectionHandles);
    const candidates = [];

    if (explicitHandle) candidates.push(explicitHandle);
    productHandles.forEach(function (handle) {
      if (candidates.indexOf(handle) === -1) {
        candidates.push(handle);
      }
    });

    for (let i = 0; i < candidates.length; i += 1) {
      const handle = candidates[i];
      if (index.collections.has(handle)) {
        return {
          handle: handle,
          entry: index.collections.get(handle)
        };
      }
    }

    if (!candidates.length) return null;

    return {
      handle: candidates[0],
      entry: null
    };
  }

  function renderItems(items, options) {
    const separatorText = options.separatorText || '>';
    const separatorClass = options.separatorClass ? ' class="' + options.separatorClass + '"' : '';
    const currentClass = options.currentClass ? ' class="' + options.currentClass + '"' : '';
    const linkClass = options.linkClass ? ' class="' + options.linkClass + '"' : '';

    return items
      .map(function (item, index) {
        const separator = index === 0 ? '' : '<span' + separatorClass + '>' + escapeHtml(separatorText) + '</span>';

        if (item.type === 'link') {
          return separator + '<a' + linkClass + ' href="' + escapeHtml(item.url) + '">' + escapeHtml(item.title) + '</a>';
        }

        return separator + '<span' + currentClass + ' aria-current="page">' + escapeHtml(item.title) + '</span>';
      })
      .join('');
  }

  function buildGlobalBreadcrumbItems(nav, index) {
    const dataset = nav.dataset;
    const items = [];

    pushLink(items, dataset.homeLabel || 'Home', dataset.homeUrl || '/');

    switch (dataset.pageType) {
      case 'product': {
        const mappedCollection = findMappedCollection(dataset, index);

        if (mappedCollection && mappedCollection.entry) {
          pushCategoryPath(items, mappedCollection.entry);
        } else {
          pushParentPage(items, dataset);
          pushLink(
            items,
            dataset.collectionTitle || dataset.fallbackCollectionTitle,
            dataset.collectionUrl || dataset.fallbackCollectionUrl
          );
        }

        pushCurrent(items, dataset.productTitle);
        break;
      }

      case 'collection': {
        const mappedCollection =
          dataset.collectionHandle && index.collections.has(dataset.collectionHandle)
            ? index.collections.get(dataset.collectionHandle)
            : null;

        if (mappedCollection) {
          pushCategoryPath(items, mappedCollection, {
            currentCollection: dataset.collectionTitle || mappedCollection.collection.title
          });
        } else {
          pushParentPage(items, dataset);
          pushCurrent(items, dataset.collectionTitle);
        }
        break;
      }

      case 'page': {
        const topCategoryPage =
          dataset.pageHandle && index.pages.has(dataset.pageHandle) ? index.pages.get(dataset.pageHandle) : null;

        if (topCategoryPage) {
          pushCurrent(items, dataset.pageTitle || topCategoryPage.title);
        } else {
          pushParentPage(items, dataset);
          pushCurrent(items, dataset.pageTitle);
        }
        break;
      }

      case 'blog':
        if (dataset.blogHandle === 'all-blogs') {
          pushCurrent(items, dataset.blogDirectoryTitle || 'All Blogs');
        } else {
          pushLink(items, dataset.blogDirectoryTitle || 'All Blogs', dataset.blogDirectoryUrl || '/blogs/all-blogs');
          pushCurrent(items, dataset.blogTitle);
        }
        break;

      case 'article':
        pushLink(items, dataset.blogDirectoryTitle || 'All Blogs', dataset.blogDirectoryUrl || '/blogs/all-blogs');

        if (dataset.blogHandle && dataset.blogHandle !== 'all-blogs') {
          pushLink(items, dataset.blogTitle, dataset.blogUrl);
        }

        pushCurrent(items, dataset.articleTitle);
        break;

      default:
        pushParentPage(items, dataset);
        pushCurrent(items, dataset.pageTitle || dataset.collectionTitle || dataset.productTitle || dataset.blogTitle);
        break;
    }

    return items;
  }

  function enhanceGlobalBreadcrumbs(index) {
    document.querySelectorAll(globalBreadcrumbSelector).forEach(function (nav) {
      const items = buildGlobalBreadcrumbItems(nav, index);

      if (items.length > 1) {
        nav.innerHTML = renderItems(items, {
          separatorText: '>'
        });
      }
    });
  }

  function enhanceArticleBreadcrumbs() {
    document.querySelectorAll(articleBreadcrumbSelector).forEach(function (container) {
      const dataset = container.dataset;
      const items = [];

      pushLink(items, dataset.blogDirectoryTitle || 'All Blogs', dataset.blogDirectoryUrl || '/blogs/all-blogs');

      if (dataset.blogHandle && dataset.blogHandle !== 'all-blogs') {
        pushLink(items, dataset.blogTitle, dataset.blogUrl);
      }

      if (items.length) {
        container.innerHTML = renderItems(items, {
          linkClass: 'article-template__crumb-link',
          separatorClass: 'article-template__crumb-separator',
          separatorText: '/'
        });
      }
    });
  }

  function init() {
    enhanceArticleBreadcrumbs();

    getCategoryData().then(function (payload) {
      const index = buildCategoryIndex(payload || {});
      enhanceGlobalBreadcrumbs(index);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
